import {Button, Checkbox, Col, DatePicker, Drawer, Form, Input, InputNumber, Row, Select} from "antd";

const { TextArea } = Input;

function FormDrawer({ open, onClose, onSubmit, onChange, items, title, loading = false, width = 500, form }) {
    return (
        <Drawer
            title={title}
            open={open}
            onClose={onClose}
            width={width}
        >
            {form ? (
            <Form
                form={form}
                layout="vertical"
                onFinish={onSubmit}
            >
                <Row
                    gutter={16}
                >
                {items.map((value, index) => {
                    return (
                        <Col
                            key={index}
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={12}
                        >
                            <Form.Item
                                initialValue={value.initValue}
                                name={value.name}
                                label={value.label}
                                rules={[
                                    {
                                        required: value.required,
                                    }
                                ]}
                            >
                                {(() => {
                                    if (value.type === 'text') {
                                        return (
                                            <Input
                                                placeholder={value.placeholder}
                                                disabled={value.disabled}
                                            />
                                        )
                                    }
                                    else if (value.type === 'password') {
                                        return (
                                            <Input.Password
                                                placeholder={value.placeholder}
                                            />
                                        )
                                    }
                                    else if (value.type === 'select') {
                                        return (
                                            <Select
                                                style={{
                                                    width: '100%'
                                                }}
                                                options={value.options}
                                                placeholder={value.placeholder}
                                                showSearch={true}
                                                optionFilterProp={'label'}
                                                onChange={onChange}
                                            />
                                        )
                                    }
                                    else if (value.type === 'checkbox-group') {
                                        return (
                                            <Checkbox.Group
                                                options={value.options}
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '8px'
                                                }}
                                            />
                                        )
                                    }
                                    else if (value.type === 'number') {
                                        return (
                                            <InputNumber
                                                style={{
                                                    width: '100%'
                                                }}
                                                placeholder={value.placeholder}
                                                min={0}
                                                disabled={value.disabled}
                                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                            />
                                        )
                                    }
                                    else if (value.type === 'date') {
                                        return (
                                            <DatePicker
                                                style={{
                                                    width: '100%'
                                                }}
                                                placeholder={value.placeholder}
                                                format="DD/MM/YYYY"
                                            />
                                        )
                                    }
                                    else if (value.type === 'textarea') {
                                        return (
                                            <TextArea
                                                placeholder={value.placeholder}
                                                rows={4}
                                                disabled={value.disabled}
                                            />
                                        )
                                    }
                                })()}
                            </Form.Item>
                        </Col>
                    )
                })}
                <Col span={24}>
                    <Button loading={loading} type={'primary'} htmlType={'submit'}>Xác nhận</Button>
                </Col>
                </Row>
            </Form>
            ) : (
                <Row
                    gutter={16}
                >
                {items.map((value, index) => {
                    return (
                        <Col
                            key={index}
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={12}
                        >
                            <Form.Item
                                initialValue={value.initValue}
                                name={value.name}
                                label={value.label}
                                rules={[
                                    {
                                        required: value.required,
                                    }
                                ]}
                            >
                                {(() => {
                                    if (value.type === 'text') {
                                        return (
                                            <Input
                                                placeholder={value.placeholder}
                                                disabled={value.disabled}
                                            />
                                        )
                                    }
                                    else if (value.type === 'password') {
                                        return (
                                            <Input.Password
                                                placeholder={value.placeholder}
                                            />
                                        )
                                    }
                                    else if (value.type === 'select') {
                                        return (
                                            <Select
                                                style={{
                                                    width: '100%'
                                                }}
                                                options={value.options}
                                                placeholder={value.placeholder}
                                                showSearch={true}
                                                optionFilterProp={'label'}
                                                onChange={onChange}
                                            />
                                        )
                                    }
                                    else if (value.type === 'checkbox-group') {
                                        return (
                                            <Checkbox.Group
                                                options={value.options}
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '8px'
                                                }}
                                            />
                                        )
                                    }
                                    else if (value.type === 'number') {
                                        return (
                                            <InputNumber
                                                style={{
                                                    width: '100%'
                                                }}
                                                placeholder={value.placeholder}
                                                min={0}
                                                disabled={value.disabled}
                                                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                            />
                                        )
                                    }
                                    else if (value.type === 'date') {
                                        return (
                                            <DatePicker
                                                style={{
                                                    width: '100%'
                                                }}
                                                placeholder={value.placeholder}
                                                format="DD/MM/YYYY"
                                            />
                                        )
                                    }
                                    else if (value.type === 'textarea') {
                                        return (
                                            <TextArea
                                                placeholder={value.placeholder}
                                                rows={4}
                                                disabled={value.disabled}
                                            />
                                        )
                                    }
                                })()}
                            </Form.Item>
                        </Col>
                    )
                })}
                <Col span={24}>
                    <Button onClick={onSubmit} loading={loading} type={'primary'} htmlType={'submit'}>Xác nhận</Button>
                </Col>
                </Row>
            )}
        </Drawer>
    )
}

export default FormDrawer;
